// Last recorded weight for an animal. Pure function — no stores, no JSX,
// never mutates the input (allWeights is copied before sorting).
//
// Same rule as the journal header in newJournal.js: the most-recent-dated
// entry in animal.allWeights wins, falling back to the animal's own weight
// field when no dated entries exist (TICKET-01286: the prescription drawer
// shows this so the vet doesn't have to close the drawer to check weight).
export function getLastRecordedWeight(animal) {
    if (!animal) {
        return { weight: null, date: null };
    }
    const allWeights = Array.isArray(animal.allWeights) ? animal.allWeights : [];
    if (allWeights.length === 0) {
        return { weight: animal.weight || null, date: null };
    }
    const sorted = [...allWeights].sort((a, b) => new Date(a.date) - new Date(b.date));
    const last = sorted[sorted.length - 1];
    return { weight: last.weight || null, date: last.date || null };
}
